<template>
  <b-form
    :id="formId"
    class="modal-form"
    @submit.prevent="insertOrUpdate"
    @reset="onReset"
  >
    <div class="card card-default">
      <div class="card-body">
        <div
          v-if="!_.isEmpty(errors)"
          class="alert alert-danger"
        >
          <strong>{{ $t('JSON.whoops') }}!</strong> {{ $t('JSON.there-were-some-problems-with-your-input') }}<br><br>
          <ul>
            <li
              v-for="(error, key) in errors"
              :key="key"
            >
              {{ error }}
            </li>
          </ul>
        </div>

        <VueFormGenerator
          :schema="form.schema"
          :model="form.model"
          :options="form.options"
        />

        <div class="col-lg-12 col-md-12">
          <div class="modal-btn text-center">
            <button
              type="submit"
              class="btn btn-default"
            >
              {{ $t('JSON.save') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </b-form>
</template>

<script>
import formHelpers from '@/mixins/admin/helpers/form-helpers';

export default {

  mixins: [formHelpers],

  props: {
    mode: {
      type: String,
      default: () => ('add'),
    },
    site: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      listener: null,
      errors: {},
      api: {
        add: '/api/spawner/admin/sites',
        edit: `/api/spawner/admin/sites/${this.site.id}`,
      },
    };
  },

  computed: {
    _() {
      return _;
    },

    formId() {
      return 'site-form';
    },
  },

  mounted() {
    this.generateSchema('spawner', 'Site', this.mode);
    this.initForm();
  },

  methods: {
    onReset() {
      console.log('resetting form');
      this.errors = {};
    },

    clearForm() {
      this.form.site = '';
    },

    initForm() {
      if (this.site) {
        console.log('siteForm.initForm.site', this.site);
        this.loadModel(this.site);
      }
    },
  },
};
</script>
